import classNames from "classnames";
import styles from "./TextInput.module.scss";

const TextInput = ({ className, inputRef, ...inputProps }) => {
  return (
    <input
      className={classNames(
        styles.textInput,
        className,
      )}
      type="text"
      ref={inputRef}
      {...inputProps}
    />
  );
};

export default TextInput;
